import DragController from 'components/drag-controller/DragController';
import { bindEmitterMethod, bindMethod } from 'helpers/bind';
import Component from 'navigation/component/Component';
class EditorialRelatedContent extends Component {
    initialized() {
        super.initialized();
    }
    getModulesMap() {
        return {
            dragController: ['.editorial-related-content__list-wrapper', DragController]
        };
    }
    getModuleParams(el, componentConstructor) {
        return {
            itemsVisible: 3
        };
    }
    bindEvents(add) {
        const emitterMethod = bindEmitterMethod(add);
        const method = bindMethod(add);
        this.modules.dragController[emitterMethod]('move', () => this.onMove());
        if (this.refs.prev && this.refs.next) {
            this.refs.prev[method]('click', () => this.modules.dragController.navigate(-1));
            this.refs.next[method]('click', () => this.modules.dragController.navigate(1));
        }
    }
    onMove() {
        if (!this.refs.next && !this.refs.prev)
            return;
        this.refs?.prev.classList.toggle('disabled', this.modules.dragController.progress === 0);
        const isAtBeginning = this.modules.dragController.progress === 0;
        this.refs?.prev[isAtBeginning ? 'setAttribute' : 'removeAttribute']('disabled', '');
        const isAtEnd = this.modules.dragController.progress === 1;
        this.refs.next.classList.toggle('disabled', this.modules.dragController.progress === 1);
        this.refs.next[isAtEnd ? 'setAttribute' : 'removeAttribute']('disabled', '');
    }
}
export default EditorialRelatedContent;
